import { Flex } from '@chakra-ui/layout';
import { Menu, MenuButton } from '@chakra-ui/menu';
import { Box, Icon, IconButton, Portal, Tag } from '@chakra-ui/react';
import { IconDotGrid1x3Vertical } from 'central-icons/IconDotGrid1x3Vertical';

import { DeliveryStatus } from '@revelio/data-access';

import type { ReportRun } from '../../CustomDash/components/Reports/types';
import { CustomReportMenuList } from '../components/custom-report-menu-list';
import { MiddlewareReportMenuList } from '../components/mw-report-menu-list';
import type { useAllReports } from '../hooks/use-all-reports';
import { tagStatusColorMap } from '../utils/status-tag-colors';

export const ReportsStatusColumn = ({
  viewReportLink,
  value,
  report,
  customReportRun,
  refreshReports,
}: {
  viewReportLink: string | null;
  report: ReturnType<typeof useAllReports>['reports'][number] | null;
  customReportRun: ReportRun | null;
  reportStatus: DeliveryStatus;
  value: string;
  refreshReports: () => void;
}) => {
  const showMenu =
    [DeliveryStatus.Finished, DeliveryStatus.Failed].includes(
      value as DeliveryStatus
    ) && report;

  const stopPropagation = (e: React.MouseEvent<HTMLElement>) => {
    e.stopPropagation();
  };

  const tagStatus =
    value === DeliveryStatus.Scheduled ? DeliveryStatus.Running : value;

  return (
    <Flex justifyContent="space-between">
      <Tag
        size="md"
        variant="solid"
        bgColor={tagStatusColorMap[tagStatus]?.bgColor || 'gray.100'}
        color={tagStatusColorMap[tagStatus]?.color || 'gray.600'}
        fontWeight="semibold"
      >
        {tagStatus}
      </Tag>

      {showMenu && (
        <Menu placement="left-start">
          <MenuButton
            as={IconButton}
            icon={
              <Icon
                as={IconDotGrid1x3Vertical}
                data-testid="reports_status_menu_button"
              />
            }
            size="xs"
            colorScheme="gray"
            onClick={stopPropagation}
          >
            Actions
          </MenuButton>
          <Portal>
            <Box onClick={stopPropagation}>
              {report?.reportType === 'CustomReport' ? (
                <CustomReportMenuList
                  reportRun={customReportRun as ReportRun}
                  onActionSucceeded={() => {
                    refreshReports();
                  }}
                />
              ) : (
                <MiddlewareReportMenuList
                  viewReportLink={viewReportLink}
                  report={report}
                  onActionSucceeded={refreshReports}
                />
              )}
            </Box>
          </Portal>
        </Menu>
      )}
    </Flex>
  );
};
